class TaskExecutor {
  // 单例模式实现
  static instance: TaskExecutor | null = null

  private taskQueue: (() => Promise<void>)[] = [] // 任务队列
  private isProcessingQueue = false // 是否正在处理队列

  private constructor() {} // 私有构造函数，防止外部实例化

  public static getInstance(): TaskExecutor {
    if (!this.instance) {
      this.instance = new TaskExecutor()
    }
    return this.instance
  }

  public async executeTask(task: () => Promise<void>): Promise<void> {
    this.taskQueue.push(task) // 将任务加入队列
    if (!this.isProcessingQueue) {
      // 如果队列未在处理中，启动队列处理
      await this.processTaskQueue()
    }
  }

  public async processTaskQueue(): Promise<void> {
    this.isProcessingQueue = true // 标记队列正在处理
    try {
      while (this.taskQueue.length > 0) {
        // 循环处理队列中的任务
        const task = this.taskQueue.shift() // 取出队列中的第一个任务
        // console.log("debug=  task=",task)
        try {
          if (task) {
            await task() // 执行任务
          }
        } catch (error) {
          console.error('Task execution error:', error) // 处理任务执行错误
        }
      }
    } finally {
      this.isProcessingQueue = false // 标记队列处理完成
    }
  }
}

export default TaskExecutor
